import { render, staticRenderFns } from "./CmsSopContentPre.vue?vue&type=template&id=24c92d2a&scoped=true&"
import script from "./CmsSopContentPre.vue?vue&type=script&lang=js&"
export * from "./CmsSopContentPre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c92d2a",
  null
  
)

export default component.exports